import { motion } from "framer-motion";
import SearchBar from "./SearchBar";

export default function HelpHero({ onSearch }) {
  return (
    <section className="relative py-8 bg-emerald-50">
      <div className="px-4 mx-auto max-w-6xl sm:px-6">
        <button onClick={() => window.history.back()} className="inline-flex gap-2 items-center text-xs text-emerald-700 hover:underline">
          ← Back
        </button>
        <div className="mt-3 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="text-xl font-extrabold text-gray-900 sm:text-2xl"
          >
            Hello, Welcome to Trip Secure Help Center?
          </motion.h1>
          <div className="mt-4">
            <SearchBar onSearch={onSearch} />
          </div>
          <p className="mt-4 text-xs text-gray-700">
            or Browse our categories to find quick answers, guides, and support
          </p>
        </div>
      </div>
    </section>
  );
}


